import { render, staticRenderFns } from "./PokemonTypeDetail.vue?vue&type=template&id=71180e13&"
import script from "./PokemonTypeDetail.vue?vue&type=script&lang=ts&"
export * from "./PokemonTypeDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports